import React, { useState, createContext, useContext, useEffect } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  user: null,
  login: () => {},
  logout: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedUser = sessionStorage.getItem('session_user');
      //console.log("Stored User:", storedUser); // 디버깅용 로그
      try {
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          //console.log("Parsed User:", parsedUser); // 파싱된 데이터 확인
          setUser(parsedUser);
          setIsLoggedIn(true);
        }
      } catch (error) {
        console.error('Failed to parse session user:', error); // 오류 처리
      }
    }
  }, []); // 이 `useEffect`는 컴포넌트가 마운트될 때 한 번 실행됩니다.

  const login = (userData) => {
    //console.log("UserData during login:", userData); 
    sessionStorage.setItem('session_user', JSON.stringify(userData));
    setIsLoggedIn(true);
    setUser(userData);
  };

  const logout = () => {
    sessionStorage.removeItem('session_user');
    setIsLoggedIn(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};